import React, { useRef } from "react";
import { AppState } from "../../store/reducer";
import { connect } from "react-redux";
import { Data } from "../../framework/data";
import { LeagueHeaderWithCurrentUserAssignment } from "../../store/leagues/models";
import { loadOpenLeagues } from "../../store/leagues/actions";
import { Dispatch } from "redux";
import { openLeaguesByCity } from "../../store/leagues/selectors";
import LeagueGroups from "./LeagueGroups";
import { Player } from "../../store/players/models";
import { currentPlayer } from "../../store/players/selectors";
import { getConfig } from "../../config/configuration";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { Typography, Grid, Badge, Button, useTheme, useMediaQuery, Select, MenuItem, Link, Chip, CircularProgress } from "@material-ui/core";
import DescriptionIcon from '@material-ui/icons/Description';
import { Alert, AlertTitle } from "@material-ui/lab";
import { withRouter, match } from "react-router-dom";
import { getLatestSeasonMatches } from "../../store/matches/actions";
import { MatchHeader } from "../../store/matches/models";
import NewestMatches from "../matches/NewestMatches";
import { currentSeasonNewestMatchesWithLeagues, MatchHeaderWithLeagueInfo } from "../../store/matches/selectors";
import NewestMatchesInSeason from "../matches/NewestMatchesInSeason";

interface LeaguePageProps {
  match: match<{ year: string }>;
  leagues?: Data<{ [key: string]: LeagueHeaderWithCurrentUserAssignment[] }>;
  player?: Data<Player>;
  matches: Data<MatchHeaderWithLeagueInfo[]>;
  loadLeagues?: (year?: string) => void;
  loadNewestSeasonMatches?: (year: string) => void;
}

const LeaguesPage: React.FC<LeaguePageProps> = ({
  match,
  leagues,
  loadLeagues,
  loadNewestSeasonMatches,
  matches
}) => {

  var theme = useTheme();

  const [availableYears, setAvailableYears] = React.useState<string[]>([]);
  const [defaultSeason, setDefaultSeason] = React.useState<string>("2023-3");
  const [otherCities, setOtherCities] = React.useState<{ name: string, url: string }[]>([]);
  const [uiLeaguePrefixToRemove, setUiLeaguePrefixToRemove] = React.useState<string>("");
  const [config, setConfig] = React.useState<any>();

  const season = match.params.year;
  const newestMatches = useRef(null);


  const setViewedYear = React.useCallback((year: string) => window.location.assign(`/#/leagues/${year}`), []);

  React.useEffect(() => {
    getConfig().then((config) => {
      setConfig(config)
      setAvailableYears(config.seasons);
      setDefaultSeason(config.defaultSeason);
      setOtherCities(config.otherCities);
      setUiLeaguePrefixToRemove(config.uiSeasonPrefix);
    });
  }, []);

  React.useEffect(() => {
    loadLeagues && loadLeagues(season);
    if (!!season) {
      loadNewestSeasonMatches && loadNewestSeasonMatches(season);
    }
  }, [season]);

  console.log()

  React.useEffect(() => {

    if (window.location.href.endsWith("?newest")) {
      (newestMatches.current! as any).scrollIntoView({ behavior: 'smooth' });
    }

  }, [window.location.href, leagues?.type, matches.type])

  return (
    <Grid container spacing={2} direction="column">
      <Grid item xs={12}>

        {config?.key === "prod" || config?.key === "local" ? (

          <Alert severity="info" style={{ marginBottom: 16, maxWidth: '84vw' }}>
            <AlertTitle>Sezon 2026/3</AlertTitle>
            <Grid container spacing={2}>
              <Grid item>
                <Typography variant="body2">Nowy sezon startuje w Krakowie 7 września. <br /> Dołącz do rozgrywek klikając przycisk poniżej!
              <br /><br />
                  <Link href="https://photos.app.goo.gl/1ivRWjbDK2RaYV7NA" target="_blank"> <b>Link do zdjęc z ostatnich finałów 2026/1</b></Link>
                  <br />
                  <Link href="https://www.youtube.com/shorts/GzUiwINEMK4" target="_blank"> <b>Link do video z ostatnich finałów 2026/1</b></Link>
                </Typography>
              </Grid>
              <Grid item>
                <Link href="https://www.instagram.com/p/DcUQYV0DpRf/?igsi=MzRlODBiNWFlZA%3D%3D" target="_blank" rel="noopener">
                  <img src="d9cc3c85-3939-42f7-b2eb-0de5befb3b77.jpeg" style={{ width: '100%' }} />
                </Link>
              </Grid>
            </Grid>
          </Alert>
        ) : (<></>)
        }
        <Button color="primary" variant="contained" href="/#/signup" startIcon={
          <DescriptionIcon />
        }>Zapisz się</Button>
      </Grid>
      <Grid item xs={12}>
        <LeagueGroups
          groups={leagues!}
        ></LeagueGroups>

        <Grid container alignItems="center" spacing={2}>
          <Grid item>
            <Typography variant="h6">Sezony:</Typography>
          </Grid>
          <Grid item xs={12}>
            <Select value={season} onChange={(evt: React.ChangeEvent<any>) => { setViewedYear(evt.target.value) }} variant="outlined">
              {
                availableYears.map((y, i) => (
                  <MenuItem key={i} value={y}>
                    {y.replace("-", "/").replace(uiLeaguePrefixToRemove, "").replace("_", " ")}
                    {
                      i === 0 && y !== defaultSeason ? (<Chip color={"primary"} size={"small"} label={"!"}></Chip>) : (<></>)
                    }
                  </MenuItem>
                ))
              }
            </Select>

          </Grid>


          {
            !!otherCities && otherCities.length > 0 ? (<Grid container alignItems="center" spacing={2} style={{ marginTop: theme.spacing(2) }}>
              <Grid item>
                <Typography variant="h6">Inne miasta:</Typography><Grid item xs={12}>
                  <ToggleButtonGroup
                    exclusive
                    value={season}
                    onChange={(_, value: string) => { window.open(value, "_blank") }}

                  >
                    {
                      (otherCities || []).map((city, i) => (
                        <ToggleButton key={i} value={city.url} style={{ width: "100%" }}>
                          {city.name}
                        </ToggleButton>
                      ))
                    }
                  </ToggleButtonGroup>
                </Grid>
              </Grid></Grid>) : (<></>)
          }

          <Grid item xs={12}>
            <div ref={newestMatches}>&nbsp;</div>
            <Typography variant="h5" color="primary" >
              Najnowsze wyniki
            </Typography>
            {matches.type === "LOADED" ? (
              <NewestMatchesInSeason matches={matches.value}></NewestMatchesInSeason>
            ) : (
                <div
                  style={{
                    width: "64px",
                    height: "64px",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                >
                  <CircularProgress />
                </div>
              )}
          </Grid>
        </Grid>



      </Grid>
    </Grid >
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    leagues: openLeaguesByCity(state),
    player: currentPlayer(state),
    matches: currentSeasonNewestMatchesWithLeagues(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    loadLeagues: (year?: string) => dispatch(loadOpenLeagues(year)),
    loadNewestSeasonMatches: (season: string) => dispatch(getLatestSeasonMatches({ season }))
  }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LeaguesPage));
